<template>
    <div>
        <p class="title is-5">Bonus coupons</p>
        <p class="title help is-6">
            To fully setting the bonus, configure in the 
            <router-link :to="{ name: 'branch-list' }" target="_blank">client settings</router-link>
             -> branch -> Bonuses settings -> Coupons
            <span class="has-text-danger">(client setting == branch setting)</span>
        </p>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Enabled</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="bonus.enabled" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Convert to real max percent</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model.number="bonus.convertToRealMaxPercent"
                            class="input oc-input"
                            type="number"
                        />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Add currency settings</label>
            </div>
            <div class="field-body">
                <div class="field has-addons">
                    <div class="control">
                        <div class="select">
                            <select v-model="newCurrency">
                                <option
                                    v-for="currency in currencies"
                                    :key="currency.id"
                                    :value="currency.id"
                                >{{currency.id}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="control">
                        <a class="button is-success" @click="addCurrencyToBonusSettings()">Add</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Remove currency settings</label>
            </div>
            <div class="field-body">
                <div class="field has-addons">
                    <div class="control">
                        <div class="select">
                            <select v-model="removeCurrency">
                                <option
                                    v-for="currency in currencies"
                                    :key="currency.id"
                                    :value="currency.id"
                                >{{currency.id}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="control">
                        <a class="button is-danger" @click="removeCurrencyFromBonusSettings()">Remove</a>
                    </div>
                </div>
            </div>
        </div>

        <p class="title is-5">Providers settings</p>
        <article v-for="provider in bonus.providers" :key="provider.provider" class="message">
            <div class="message-header is-size-5">
                <p>{{provider.provider}}</p>
            </div>
            <div class="message-body">
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Contribution percent</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <p class="control">
                                <input
                                    v-model.number="provider.contributionPercent"
                                    class="input oc-input"
                                    type="number"
                                />
                            </p>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Min odds to contribute</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <p class="control">
                                <input
                                    v-model.number="provider.minFactor"
                                    class="input oc-input"
                                    type="number"
                                />
                            </p>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Currencies</label>
                    </div>
                    <div class="field-body"></div>
                </div>
                <div
                    class="field is-horizontal"
                    v-for="providerCurrencySettings in provider.currencies"
                    :key="providerCurrencySettings.currency"
                >
                    <div class="field-label is-normal">
                        <label class="label">{{providerCurrencySettings.currency}} max bet</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <p class="control">
                                <currency-input
                                    :value="providerCurrencySettings.maxBet"
                                    :currency="providerCurrencySettings.currency"
                                    :set="(val) => providerCurrencySettings.maxBet = val"
                                    class="input is-small oc-input"
                                />
                            </p>
                        </div>
                    </div>
                </div>

                <!-- game types -->
                <article v-for="game in provider.games" :key="game.gameType" class="message">
                    <div class="message-header">
                        <p>{{game.gameType}}</p>
                    </div>
                    <div class="message-body">
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label">Contribution percent</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <p class="control">
                                        <input
                                            v-model.number="game.contributionPercent"
                                            class="input oc-input"
                                            type="number"
                                        />
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label">Min odds to contribute</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <p class="control">
                                        <input
                                            v-model.number="game.minFactor"
                                            class="input oc-input"
                                            type="number"
                                        />
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label">Currencies</label>
                            </div>
                            <div class="field-body"></div>
                        </div>

                        <div
                            class="field is-horizontal"
                            v-for="gameCurrencySettings in game.currencies"
                            :key="gameCurrencySettings.currency"
                        >
                            <div class="field-label is-normal">
                                <label class="label">{{gameCurrencySettings.currency}} max bet</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <p class="control">
                                        <currency-input
                                            :value="gameCurrencySettings.maxBet"
                                            :currency="gameCurrencySettings.currency"
                                            :set="(val) => gameCurrencySettings.maxBet = val"
                                            class="input is-small oc-input"
                                        />
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </article>

        <div class="field is-horizontal" style="margin-top: 2rem">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import state from '../../../../../state';
import clientService from '../../../../../services/client.service';
import utils from '../../../../../utils';
import bonusSettingsHelper from './bonusSettings.helper';

import CurrencyInput from '../../../../common/currency-input.vue';

export default {
    name: 'client-settings-coupon-bonus',
    components: { CurrencyInput },
    data() {
        return {
            client: null,
            bonus: {},
            newCurrency: null,
            removeCurrency: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        currencies() {
            return state.currencies.get();
        }
    },
    watch: {
        clientId() {
            this.load();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.load();
    },
    methods: {
        load() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
            this.bonus = this.client.settings.bonusSettings.coupon;
        },
        async save() {
            this.client.settings.bonusSettings.coupon = this.bonus;
            await clientService.save(this.client);
        },
        addCurrencyToBonusSettings() {
            bonusSettingsHelper.addCurrencyToBonusSettings(this.bonus, this.newCurrency);
            this.newCurrency = null;
        },
        removeCurrencyFromBonusSettings() {
            bonusSettingsHelper.removeCurrencyFromBonusSettings(this.bonus, this.removeCurrency);
            this.removeCurrency = null;
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/bonuses/coupon.vue